<ng-container *ngIf="shopExist; else NoShop">
  <!-- <i class="fa-solid fa-shop menu-option" (click)="openShopProfile()"></i> -->

  <!-- <i class="fa fa-ellipsis-v menu-option" aria-hidden="true" id="shopMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
  <div class="dropdown-menu" aria-labelledby="shopMenu" style="width: 10px"> -->
  <!-- <a class="dropdown-item" (click)="openShopProfile()" *ngIf="roleService.roles?.users?.includes('MEMBER_SHOP')">Shop</a> -->
  <!-- <a class="dropdown-item" (click)="updateSelMenu(3)">History</a> -->
  <!-- <a class="dropdown-item">Learn</a> -->
  <!-- </div> -->

  <app-my-tabs [tabs]="tabs" [defaultTabIndex]="selMenu" (tabChange)="updateSelMenu($event)">
    <div class="my-shop" allTab>
      <div class="nav-product">
        <div class="nav-product__title" *ngIf="selMenu != 3">
          Products
          <a routerLink="/shop-page" (click)="closeDash()"> manage </a>
        </div>
        <button *ngIf="selMenu != 3" class="button-2" id="add-product" (click)="openShopAction('add_product')">
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span class="pl-1">Add</span>
        </button>
      </div>
      <div class="my-shop__products-2">
        <div class="my-shop__products-2--item" *ngFor="let i of productAllProductListFiltered">
          <span class="att-product" *ngIf="i.ProductsAttachmentToKey" title="Remove Attachment" (click)="deleteProductsAttachment(i.ProductsAttachmentToKey)"> <i class="fa fa-plus" aria-hidden="true"></i></span>
          <img loading="lazy" (click)="openShopAction('edit_product', i)" src="{{ imgUrl }}{{ i?.primaryImage }}" />

          <div class="my-shop__products-2--item__name">
            {{ i?.name | titlecase }}
          </div>
          <div class="my-shop__products-2--item__meta">
            <span>{{ i.categoryName }}</span>
          </div>
          <div class="my-shop__products-2--item__meta">
            <span>{{ (i?.regionName | titlecase) + "|" + (i?.subRegionName | titlecase) }}</span>
          </div>

          <div class="my-shop__products-2--item__control">
            <app-dropdown-status [value]="i.outOfStockAll == 1 ? 5 : i.status" (change)="onSellOptChange(i, SellProduct, $event)"></app-dropdown-status>

            <!-- <div class="nav-select" *ngIf="selMenu != 3">
              <select (change)="onSellOptChange(i, SellProduct, $event.target.value)" [value]="i.type">
                <option [value]="null" selected disabled>Status</option>
                <option *ngFor="let status of STATUS" [selected]="i.status == status.value" [value]="status.value">{{ status.label }}</option>
                <option [selected]="i.outOfStockAll == 1" value="4">(Out of Stock)</option>
              </select>
            </div> -->

            <div class="options">
              <i *ngIf="selMenu != 3" class="fa fa-pencil" aria-hidden="true" title="Edit" (click)="openShopAction('edit_product', i)"></i>
              <i *ngIf="selMenu != 3" class="fa fa-trash" aria-hidden="true" title="delete" (click)="openShopAction('delete_product', i)"></i>
            </div>
          </div>
        </div>

        <div *ngIf="productAllProductListFiltered.length == 3 && selMenu != 3" (click)="openBuyDiamonds()" class="my-shop__products-2--item slots">
          <div><i class="fa fa-plus" aria-hidden="true"></i> Add Slots</div>
        </div>
      </div>
    </div>
  </app-my-tabs>
</ng-container>
<ng-template #NoShop>
  <section class="no-shop">
    <span>No Shop</span>
    <div class="justify-content-center">
      <button (click)="openShopProfile()" class="btn btn-secondary">Create Shop</button>
    </div>
  </section>
</ng-template>

<app-add-shop #AddShop [enableMemberShop]="true" [customTitle]="customTitle" (shopUpdate)="update($event)"> </app-add-shop>

<ng-template #SellProduct let-modal>
  <div class="modal-body">
    <div class="referral-link">
      <section class="m-4">
        <h3>Change product status to {{ STATUS[selectedSellOption.option].label }} ?</h3>
      </section>
      <div class="mt-5">
        <div class="cart_btn d-flex justify-content-between" style="gap: 2rem">
          <button class="com_btn add-review-btn px-2 w-50" (click)="updateProductStatus()">Yes</button>
          <button class="com_btn add-review-btn px-2 w-50" (click)="modal.dismiss('Cross click')">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
